'use client';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { OneDomainService } from '@/services/onedomain.service';
import { addEventProcessor } from '@sentry/nextjs';
import { extractOneDomain } from '@nf/utils-common/url';

const isProduction = () => OneDomainService.getEnvironmentFromOneDomain() === 'PROD';

export const SentryProvider = () => {
	const { SiteConfigsData } = useGetSiteConfigs();

	useEffect(() => {
		// 移除 !isBefore 限制，確保 deeplink login flow 的 error 也能記錄
		if (SiteConfigsData?.EnableSentry && SiteConfigsData?.SentryDSN) {
			const hostname = window?.location?.hostname || '';
			const firstDotIndex = hostname.indexOf('.');
			if (firstDotIndex > -1) {
				addEventProcessor((event) => {
					if (event.type === 'transaction') {
						const oneDomainForWeb = hostname.slice(0, firstDotIndex);
						const [randomId] = extractOneDomain(oneDomainForWeb);
						event.tags = {
							...event.tags,
							randomId: randomId,
						};
					}
					return event;
				});
			}
			Sentry.init({
				dsn: SiteConfigsData?.SentryDSN,
				defaultIntegrations: false,
				integrations: [
					Sentry.browserTracingIntegration(),
					// breadcrumbsIntegration 會 wrap 所有 fetch/XHR，有效能開銷，不加
					// globalHandlersIntegration 不加，我們用 error.tsx 手動 captureException
				],
				release: process.env.NEXT_PUBLIC_FILE_VERSION_ID,
				tracesSampleRate: isProduction() ? 0.01 : 1,
				environment: `client-${window?.location?.hostname?.includes('localhost') ? 'LOCAL' : OneDomainService.getEnvironmentFromOneDomain()}`,
			});
		}
	}, [SiteConfigsData?.EnableSentry, SiteConfigsData?.SentryDSN]);	

	return null;
}; 